import React from 'react';
import classNames from 'classnames';
import Scrollchor from 'react-scrollchor';
import { miniGazelle } from '../../../../../helpers';
import ProLink from '../../../../shared/ProLink/ProLink';
import Default from '../../options/Default';
import ProductBlue from '../../options/ProductBlue';

export default function StickyNavRenderer({ stickyNavState, props, toggleExpandedNav, expandedNavFalse }) {
    const { wrapperId, navId, navigation } = stickyNavState || {};
    const { siteMap, data: { title, links = {}, productPage, colouroptions, darkBlue, button: buttons = [] } = {} } = props || {};
    const { dataLayer } = props || {};
    const { retired } = dataLayer || {};

    const slice = productPage || darkBlue || colouroptions === "Dark Blue" ? 7 : 6;
    const nav = navigation && navigation.length > 0 ? navigation.slice(0, slice) : [];

    const showStickyItemsClasses = classNames({
        'container': true,
        'show-sticky-items': true,
        'show-active': stickyNavState?.showExpandedNav,
    });

    const navClasses = classNames({
        nav: true,
        'nav-tabs': true,
        'show-expanded-nav': stickyNavState?.showExpandedNav,
    });

    const listMarkup =
        nav.length > 0 &&
        nav.map((navItem, i) => (
            <li
                key={i}
                className={classNames({
                    'col-lg-2': (productPage && !darkBlue && colouroptions !== null && colouroptions !== "Dark Blue") || (!productPage && (!colouroptions || colouroptions === "White")),
                    'sticky-nav-item': true,
                    'active': navItem.active,
                    'flexible-width': productPage || darkBlue || colouroptions === "Dark Blue" || (productPage && !colouroptions),
                    'maximise-width-3': nav.length <= 3,
                    'maximise-width-5': nav.length <= 5,
                })}
            >
                <Scrollchor
                    to={`#${siteMap ? `site-map-item-${navItem.id}` : navItem.link}`}
                    animate={{ offset: productPage || darkBlue || colouroptions === "Dark Blue" ? -150 : 0 }}
                >
                    {productPage ? miniGazelle.label(navItem.name, true) : navItem.name}
                </Scrollchor>
            </li>
        ));

    const substainabilityNav =
        nav.length > 0 &&
        nav.map((navItem, i) => (
            <Scrollchor
                key={i}
                to={`#${siteMap ? `site-map-item-${navItem.id}` : navItem.link}`}
                animate={{ offset: -100 }}
                className="nav-title"
            >
                <li>
                    <div onClickCapture={(e) => toggleExpandedNav(e)}>
                        {productPage ? miniGazelle.label(navItem.name, true) : navItem.name}
                    </div>
                </li>
            </Scrollchor>
        ));

    const buttonMarkup =
        buttons &&
        buttons.length > 0 &&
        buttons.map((button, i) => (
            <ProLink key={i} to={button.link} className="btn btn-lg btn-default export-pdf">
                {button.title}
            </ProLink>
        ));

    const getStickyNavRenderer = () => {
        switch (colouroptions) {
            case 'Dark Blue':
                return (
                    <ProductBlue
                        title={title}
                        showStickyItemsClasses={showStickyItemsClasses}
                        darkBlue={darkBlue}
                        links={links}
                        buttonMarkup={buttonMarkup}
                        navClasses={navClasses}
                        listMarkup={listMarkup}
                        wrapperId={wrapperId}
                        navId={navId}
                        toggleExpandedNav={toggleExpandedNav}
                        retired={retired}
                        showExpandedNav={stickyNavState?.showExpandedNav}
                    />
                );
            case 'Light Blue':
            case 'Light Green':
                return (
                    <Default
                        showStickyItemsClasses={showStickyItemsClasses}
                        toggleExpandedNav={toggleExpandedNav}
                        navClasses={navClasses}
                        listMarkup={substainabilityNav}
                        wrapperId={wrapperId}
                        navId={navId}
                        showExpandedNav={stickyNavState?.showExpandedNav}
                        colouroptions={colouroptions}
                    />
                );
            case 'White':
                return (
                    <Default
                        showStickyItemsClasses={showStickyItemsClasses}
                        navClasses={navClasses}
                        listMarkup={listMarkup}
                        wrapperId={wrapperId}
                        navId={navId}
                        toggleExpandedNav={toggleExpandedNav}
                        colouroptions={colouroptions}
                    />
                );
            default:
                if (productPage) {
                    return (
                        <ProductBlue
                            title={title}
                            showStickyItemsClasses={showStickyItemsClasses}
                            darkBlue={darkBlue}
                            links={links}
                            buttonMarkup={buttonMarkup}
                            navClasses={navClasses}
                            listMarkup={listMarkup}
                            wrapperId={wrapperId}
                            navId={navId}
                            toggleExpandedNav={toggleExpandedNav}
                            retired={retired}
                            showExpandedNav={stickyNavState?.showExpandedNav}
                        />
                    );
                } else {
                    return (
                        <Default
                            showStickyItemsClasses={showStickyItemsClasses}
                            navClasses={navClasses}
                            listMarkup={listMarkup}
                            wrapperId={wrapperId}
                            navId={navId}
                            toggleExpandedNav={toggleExpandedNav}
                            colouroptions={colouroptions}
                        />
                    )
                }
        }
    }
    const StickyNavMarkup = getStickyNavRenderer();

    return { StickyNavMarkup };
}